import { List, Record } from 'immutable'
import { IShareContact, ShareContact } from './ShareContact'

export interface IShareFeedItem {
  readonly contacts: List<IShareContact>
  readonly feedItemId: string
  readonly isLoading: boolean
  readonly isSaving: boolean
}

const ShareFeedItemRecord = Record({
  contacts: List<ShareContact>(),
  feedItemId: '',
  isLoading: false,
  isSaving: false,
})

export class ShareFeedItem extends ShareFeedItemRecord
  implements IShareFeedItem {
  public static fromJS(initialState?: Partial<IShareFeedItem>) {
    if (!initialState) {
      return new ShareFeedItem()
    }

    const { contacts, ...rest } = initialState

    return new ShareFeedItem({
      contacts: contacts
        ? List(contacts.map((c) => ShareContact.fromJS(c)))
        : List<ShareContact>(),
      ...rest,
    })
  }

  public readonly contacts: List<IShareContact>
  public readonly feedItemId: string
  public readonly isLoading: boolean
  public readonly isSaving: boolean

  constructor(props?: Partial<ShareFeedItem>) {
    props ? super(props) : super()
  }
}
